import { render, staticRenderFns } from "./MarketSetModal.vue?vue&type=template&id=45ed20bc&scoped=true&"
import script from "./MarketSetModal.vue?vue&type=script&lang=js&"
export * from "./MarketSetModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketSetModal.vue?vue&type=style&index=0&id=45ed20bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed20bc",
  null
  
)

export default component.exports